import { useCallback, useEffect, useRef } from "react";
import { editTableEntity } from "../utils";

export const useTableUpdateColWidths = () => {
  "use no memo";
  const rafId = useRef<number | null>(null);

  const updateTableColWidths = useCallback((widths: number[]) => {
    if (rafId.current) cancelAnimationFrame(rafId.current);
    rafId.current = requestAnimationFrame(() => {
      editTableEntity((draft) => {
        for (const idx in widths) {
          if (widths[idx] != null) {
            if (!draft.tableColWidths) {
              draft.tableColWidths = Array.from(
                { length: draft.tableCols },
                () => 100 / draft.tableCols,
              );
            }
            draft.tableColWidths[idx] = widths[idx];
          }
        }
      });
      rafId.current = null;
    });
  }, []);

  useEffect(() => {
    return () => {
      if (rafId.current) cancelAnimationFrame(rafId.current);
    };
  }, []);

  return { updateTableColWidths };
};
